export const TableProgressBar = ({
  isTopToolbar,
}: {
  isTopToolbar: boolean;
}) => {
  return {
    color: 'green',
    'data-testid': 'table-progress-bar',
    display: isTopToolbar ? 'block' : 'none',
    size: 'md',
    value: 100,
  };
};
